import { useState, useEffect } from 'react';
import { fetchPublicTiers } from '../services/api';

export default function useTierGrid() {
  const [tiers, setTiers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    async function load() {
      setLoading(true);
      try {
        const data = await fetchPublicTiers();
        if (!mounted) return;
        setTiers(data || []);
      } catch (e) {
        if (!mounted) return;
        setError(e);
      } finally {
        if (!mounted) return;
        setLoading(false);
      }
    }

    load();
    return () => { mounted = false; };
  }, []);

  return { tiers, loading, error };
}
